import React, { createContext, useReducer } from "react";

import { initialState } from "./state";
import { reducer } from "./reducer";
import { IHeaderState, IHeaderStoreAction } from "./types";
import { withStoreValueFactory } from "../../../store";

const HeaderContext: React.Context<
	[IHeaderState, React.Dispatch<IHeaderStoreAction>]
> = createContext<any>(null)

export const HeaderProvider: React.FunctionComponent = ({ children }) => {
	return (
        <HeaderContext.Provider value={useReducer(reducer, initialState)}>
            {children}
        </HeaderContext.Provider>
	)
}

export const withHeaderStoreValue = withStoreValueFactory(HeaderContext)